import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { routes } from '../../../constants'
import { actions } from '../webhookBoleto.actions'
import { WebhookBoletoForm } from './WebhookBoletoForm'
import utils from '../../../utils'
import storage from '../../../services/stoage.service'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  let unidades = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())

  return {
    record: state.crudWebhookBoletoState.currentRecord,
    messages: state.crudWebhookBoletoState.messages,
    unidades,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
  }
}

class WebhookBoletoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
      descricaoChanged: false,
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_WEBHOOK_BOLETO}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_WEBHOOK_BOLETO}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_WEBHOOK_BOLETO}`)
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
      this.setState({ descricaoChanged: true })
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_WEBHOOK_BOLETO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  onChangeDescricao = (e) => {
    this.props.setField('descricao', e)
    this.setState({ descricaoChanged: true })
  }

  onChangeField = (fieldName, e) => {
    const field = _.get(e, 'target.name', null)
    if (field === 'ativo') {
      this.props.setField(field, _.get(e, 'target.checked', null))
      return
    }
    this.props.setField(fieldName, e)
  }

  setConfiguracaoBoleto = (data) => {
    const oid = _.get(data, 'oid', null)
    const nome = _.get(data, 'nome', '')

    this.props.setField('configuracaoBoleto.id', oid)
    this.props.setField('configuracaoBoleto.value', nome)
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <WebhookBoletoForm
        record={this.props.record}
        messages={this.props.messages}
        onChangeDescricao={this.onChangeDescricao}
        onChangeField={this.onChangeField}
        setConfiguracaoBoleto={this.setConfiguracaoBoleto}
      />
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebhookBoletoFormPageContainer)
